import { createSlice } from "@reduxjs/toolkit";

import {
  addFavouriteExpert,
  getAllExperts,
  getFavoriteExpertsList,
  getTeacherById,
  getBookmarkedExperts
} from "redux/actions";
import { TeacherModel } from "redux/models/home";

export interface IExperts {
  favoriteExperts: Array<any> | null;
  allExperts: Array<any> | null;
  loadingAllExperts: boolean;
  teacher: TeacherModel | null;
  loadingFavouriteExperts: boolean;
  addFavouriteLoading: boolean;
  loading: boolean;
  bookmarkedExperts: Array<any> | null;
}

const initial: IExperts = {
  favoriteExperts: null,
  allExperts: null,
  teacher: null,
  loadingAllExperts: false,
  loadingFavouriteExperts: false,
  addFavouriteLoading: false,
  loading: false,
  bookmarkedExperts: null
};

export const expertsSlice = createSlice({
  name: "experts",
  initialState: initial,
  reducers: {},
  extraReducers: (builder) => {
    // * get favourite experts
    builder.addCase(getFavoriteExpertsList.pending, (state, action) => {
      state.loadingFavouriteExperts = true;
    });
    builder.addCase(getFavoriteExpertsList.fulfilled, (state, action) => {
      state.loadingFavouriteExperts = false;
      state.favoriteExperts = action.payload;
    });
    builder.addCase(getFavoriteExpertsList.rejected, (state, action) => {
      state.loadingFavouriteExperts = false;
    });

    // * add favourite expert
    builder.addCase(addFavouriteExpert.pending, (state, action) => {
      state.addFavouriteLoading = true;
    });
    builder.addCase(addFavouriteExpert.fulfilled, (state, action) => {
      state.addFavouriteLoading = false;
    });
    builder.addCase(addFavouriteExpert.rejected, (state, action) => {
      state.addFavouriteLoading = false;
    });

    // * get all experts
    builder.addCase(getAllExperts.pending, (state, action) => {
      state.loadingAllExperts = true;
    });
    builder.addCase(getAllExperts.fulfilled, (state, action) => {
      state.loadingAllExperts = false;
      state.allExperts = action.payload;
    });
    builder.addCase(getAllExperts.rejected, (state, action) => {
      state.loadingAllExperts = false;
    });

    builder.addCase(getBookmarkedExperts.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getBookmarkedExperts.fulfilled, (state, action) => {
      state.loading = false;
      state.bookmarkedExperts = action.payload;
    });
    builder.addCase(getBookmarkedExperts.rejected, (state, action) => {
      state.loading = false;
    });

    // * get Teacher By Id
    builder.addCase(getTeacherById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeacherById.fulfilled, (state, action) => {
      state.loading = false;
      state.teacher = {
        ...action.payload,

        single_pack_lession: action?.payload?.single_pack_lession?.map(
          (lesson) => ({
            ...lesson,
            rating_value: action?.payload?.rating_value,
            expert: {
              thumbnail: action?.payload?.thumbnail,
              country: action?.payload?.country,
              language: action?.payload?.languages?.find(
                (language) => language?.id === lesson?.language_id
              ),
            },
          })
        ),
      };
    });
    builder.addCase(getTeacherById.rejected, (state) => {
      state.loading = false;
      state.teacher = null;
    });
  },
});

export default expertsSlice.reducer;
